import links from 'links'
import cx from 'classnames'
import { Redirect } from 'router'
import { useDevice } from 'device'
import { checkWebView } from 'helpers'
import React, { useEffect } from 'react'
import { usePurchasedModules } from 'models/city'

import PortalStickyAnnouncement from 'compositions/PortalStickyAnnouncement/PortalStickyAnnouncement'

import TopSection from './components/TopSection/TopSection'
import Banner from './components/Banner/Banner'
import { ActiveCitizenBlock, AdsBlock, BusinessBlock, EventsBlock, ServicesBlock, ProjectsBlock,
  MobileBlock, TransportBlock, MedscanBlock } from './components'

import useAnnouncement from './util/useAnnouncement'

import s from './HomePage.scss'


const HomePage: React.FC = () => {
  const { isMobile } = useDevice()
  const { isWebView } = checkWebView(!__SERVER__ ? navigator.userAgent : '')
  const { announcement, hash, isAnnouncementFetching } = useAnnouncement()

  useEffect(() => {
    const pageContent = document.getElementById('page-content')

    if (pageContent) {
      pageContent.classList.add('overflow-hidden')

      return () => {
        pageContent.classList.remove('overflow-hidden')
      }
    }
  }, [])

  const { purchasedModuleTags } = usePurchasedModules()

  const withMobileApp = purchasedModuleTags.includes('MOBILE_APP')

  const isOnlyAppeals = purchasedModuleTags.length === 1 && purchasedModuleTags.includes('PROBLEMS')

  if (isOnlyAppeals) {
    return (
      <Redirect path={links.home} to={links.appeals.root} />
    )
  }

  return (
    <>
      {
        (!isAnnouncementFetching && announcement) && (
          <PortalStickyAnnouncement
            announcement={announcement}
            hash={hash}
            withCloseButton
          />
        )
      }
      <TopSection className="1" />
      <Banner key="banner" className={cx(s.blockMargin, '2')} />
      <div className={cx('flex', { 'flex-col': isMobile })}>
        {
          purchasedModuleTags?.includes('MED_ASSIST') && (
            <MedscanBlock
              className={cx(s.blockMargin, ' flex-1 3')}
            />
          )
        }
        {
          purchasedModuleTags?.includes('PUBLIC_TRANSPORT') && (
            <TransportBlock
              className={cx(s.blockMargin, 'flex-1 3', { 'ml-24px': purchasedModuleTags?.includes('MED_ASSIST') && !isMobile })}
            />
          )
        }
      </div>
      {
        (purchasedModuleTags?.includes('PROBLEMS') || purchasedModuleTags?.includes('VOTING')) && (
          <ActiveCitizenBlock
            key="activeCitizen"
            className={cx(s.blockMargin, '4')}
            withProblems={purchasedModuleTags?.includes('PROBLEMS')}
            withVoting={purchasedModuleTags?.includes('VOTING')}
          />
        )
      }
      <ServicesBlock className={cx(s.blockMargin, '5')} modules={purchasedModuleTags} />
      {
        purchasedModuleTags?.includes('POSTER') && (
          <EventsBlock
            className={s.blockMargin}
            to={links.events.root}
          />
        )
      }
      {
        purchasedModuleTags?.includes('ADVERTISING') && (
          <AdsBlock
            className={cx(s.blockMargin, '6')}
            to={links.goodsAndServices.root}
          />
        )
      }
      {
        (purchasedModuleTags?.includes('SELL_POINT_MOVE') || purchasedModuleTags?.includes('SPACES_FOR_RENT')) && (
          <BusinessBlock
            className={cx(s.blockMargin, '7')}
            withUnsteady={purchasedModuleTags?.includes('SELL_POINT_MOVE')}
            withRent={purchasedModuleTags?.includes('SPACES_FOR_RENT')}
          />
        )
      }
      {
        (purchasedModuleTags?.includes('CITY_PROJECTS') || purchasedModuleTags?.includes('IMMORTALS')) && (
          <ProjectsBlock
            className={cx(s.blockMargin, '8')}
            isWithHeroes={purchasedModuleTags?.includes('IMMORTALS')}
            isWithPlans={purchasedModuleTags?.includes('CITY_PROJECTS')}
          />
        )
      }
      {
        (withMobileApp && !isWebView) && (
          <MobileBlock
            className={cx(s.blockMargin, '9')}
          />
        )
      }
    </>
  )
}


export default HomePage
